import { SxProps } from '@mui/material'

import theme from '../../../../shared/styles/themes/default.theme'

const styles = {
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    boxShadow: '0px 1px 4px rgba(0,0,0,0.04)',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2)
    }
  } as SxProps,

  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  } as SxProps,

  cardTitle: {
    color: '#1F2937',
    fontSize: 15,
    fontWeight: 700,
    [theme.breakpoints.down('md')]: {
      fontSize: 14
    }
  } as SxProps,

  iconWrap: {
    width: 32,
    height: 32,
    borderRadius: '8px',
    backgroundColor: '#FFF7ED',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      width: 28,
      height: 28,
      borderRadius: '6px'
    }
  } as SxProps,

  avatarRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.75),
    width: '100%'
  } as SxProps,

  senderName: {
    color: '#1F2937',
    fontSize: 16,
    fontWeight: 700,
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      fontSize: 14
    }
  } as SxProps
}

export default styles
